var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-bottom-sheet',{attrs:{"inset":"","scrollable":"","value":_vm.value},on:{"input":function (input) { return _vm.$emit('input', input); }}},[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',[_vm._v("More...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }